import React from 'react';
import { Form, Select, InputNumber } from 'antd';

import * as recurrence from '../../../../constants/recurrence-constants';
import { getMaxTagPlaceholder, getRequired } from '../../../../helpers/reccurence-helper';

const BySetPositionItem = ({ rootContainer, selectedChoice, choiceLineValue, requiredItems, isRadioGroup, maxTagCount, inputType }) => {
  return (
    <Form.Item
      wrapperCol={{ span: 24 }}
      rules={[
        {
          required: getRequired(isRadioGroup, selectedChoice, choiceLineValue, requiredItems),
          message: 'Required',
        },
      ]}
      name={['rules', 'bySetPosition']}
    >
      {!inputType || inputType === recurrence.INPUT_TYPES.MULTI_SELECT ? (
        <Select
          mode="multiple"
          placeholder="Select positions"
          getPopupContainer={rootContainer}
          style={{
            width: '100%',
          }}
          disabled={isRadioGroup && selectedChoice !== choiceLineValue}
          optionFilterProp="children"
          filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
          maxTagCount={!maxTagCount ? 1 : maxTagCount}
          maxTagPlaceholder={getMaxTagPlaceholder}
          options={recurrence.POSITIONS.map((obj) => ({
            value: obj.value,
            label: obj.title,
            title: obj.title,
          }))}
        />
      ) : (
        <InputNumber
          disabled={isRadioGroup && selectedChoice !== choiceLineValue}
          placeholder="Set a position"
          min={-5}
          max={5}
          style={{ width: '100%' }}
        />
      )}
    </Form.Item>
  );
};

export default BySetPositionItem;
